import { baseGlobals } from '@root/typescript/baseGlobals'

/**
 * EventName validáláls. DEV-ben, ha nem „Game”-el kezdődik, akkor Error.
 * @param eventName - Event neve.
 * @throws Rossz a név.
 */
export default function validateEventName (eventName: string): void {
  if (baseGlobals.isDev && !eventName.startsWith('Game')) {
    throw new SyntaxError('[GameEventHandler] Csak a Game namespace eventekről lehet leiratkozni!')
  }
}
